$(function () {
    const $dialog = $('.video-modal');
    if (!$dialog.length) {
        return;
    }

    const $section = $dialog.closest('.g-content__video-library-section');
    $dialog.appendTo('body');

    const $player = $dialog.find('.video-modal__video');
    const $thumbnail = $dialog.find('.video-modal__thumbnail');
    const $thumbnailImg = $thumbnail.find('.video-modal__thumbnail-img');
    const $shareBtn = $dialog.find('.video-modal__share');
    const $triggers = $('.video-library__card');

    let currentVideoId = null;
    let currentMode = null;

    function findTriggerById(id) {
        return $triggers.filter(function () {
            return $(this).attr('data-video-id') === id;
        });
    }

    function clearUrlParam() {
        const url = new URL(window.location.href);
        if (url.searchParams.has('v')) {
            url.searchParams.delete('v');
            window.history.replaceState({}, '', url);
        }
    }

    function getTriggerThumb($trigger) {
        return $trigger.find('.video-library__card-thumbnail img').attr('src') || '';
    }

    function setShareUrl(videoId) {
        const url = window.location.origin + window.location.pathname + '?v=' + videoId;
        $shareBtn.attr('data-share-url', url).find('.video-modal__share-text').text('Share');
    }

    function openIframeMode(videoId) {
        const $trigger = findTriggerById(videoId);
        if (!$trigger.length) {
            return;
        }
        const embed = $trigger.attr('data-video-embed');
        if (!embed) {
            return;
        }

        currentVideoId = videoId;
        currentMode = 'iframe';

        setShareUrl(videoId);
        $thumbnail.attr('hidden', true).removeClass('is-active is-leaving').find('img').attr('src', '');
        $player.attr('src', embed);
        $dialog.addClass('is-open');
        $('body').css('overflow', 'hidden');
    }

    function openThumbnailMode(videoId) {
        const $trigger = findTriggerById(videoId);
        if (!$trigger.length) {
            clearUrlParam();
            return;
        }
        const thumb = getTriggerThumb($trigger);

        currentVideoId = videoId;
        currentMode = 'thumbnail';

        setShareUrl(videoId);
        $player.attr('src', '');
        $thumbnailImg.attr('src', thumb);
        $thumbnail.removeAttr('hidden');
        void $thumbnail[0].offsetWidth;
        $thumbnail.addClass('is-active');
        $dialog.addClass('is-open');
        $('body').css('overflow', 'hidden');
    }

    function promoteToIframe() {
        if (currentMode !== 'thumbnail' || !currentVideoId) {
            return;
        }
        const $trigger = findTriggerById(currentVideoId);
        if (!$trigger.length) {
            return;
        }
        const embed = $trigger.attr('data-video-embed');
        if (!embed) {
            return;
        }

        $thumbnail.addClass('is-leaving');

        setTimeout(function () {
            $player.attr('src', embed);
            $thumbnail.attr('hidden', true).removeClass('is-active is-leaving').find('img').attr('src', '');
            currentMode = 'iframe';
        }, 250);
    }

    function closeModal() {
        $player.attr('src', '');
        $thumbnail.attr('hidden', true).removeClass('is-active is-leaving').find('img').attr('src', '');
        $dialog.removeClass('is-open');
        $('body').css('overflow', '');

        currentVideoId = null;
        currentMode = null;
        clearUrlParam();
    }

    $triggers.on('click', function (e) {
        e.preventDefault();
        const $t = $(this);
        const videoId = $t.attr('data-video-id');
        if (!videoId) {
            return;
        }
        if (currentMode === 'thumbnail' && currentVideoId === videoId) {
            promoteToIframe();
            return;
        }
        openIframeMode(videoId);
    });

    $thumbnail.on('click', function (e) {
        e.stopPropagation();
        promoteToIframe();
    });

    $dialog.on('click', function (e) {
        if (!$(e.target).closest('.video-modal__dialog').length) {
            closeModal();
        }
    });

    $dialog.find('.video-modal__close').on('click', function (e) {
        e.stopPropagation();
        closeModal();
    });

    function copyToClipboard(text, onSuccess) {
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(text).then(onSuccess);
            return;
        }
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.select();
        try {
            document.execCommand('copy');
            onSuccess();
        } catch (e) {}
        document.body.removeChild(textarea);
    }

    $shareBtn.on('click', function (e) {
        e.stopPropagation();
        const url = $shareBtn.attr('data-share-url');
        if (!url) return;
        copyToClipboard(url, function () {
            const $text = $shareBtn.find('.video-modal__share-text');
            $text.text('Copied!');
            $shareBtn.addClass('video-modal__share--copied');
            setTimeout(function () {
                $text.text('Share');
                $shareBtn.removeClass('video-modal__share--copied');
            }, 2000);
        });
    });

    $(document).on('keydown', function (e) {
        if (e.key === 'Escape' && $dialog.hasClass('is-open')) {
            closeModal();
        }
    });

    const initialVideoId = new URLSearchParams(window.location.search).get('v');
    if (initialVideoId && $section.length) {
        $('html, body').animate({ scrollTop: $section.offset().top }, 300, function () {
            openThumbnailMode(initialVideoId);
        });
    }

    $('.video-library__grid').each(function () {
        const $grid = $(this);
        const $block = $grid.closest('.video-library-block');
        const $cards = $grid.find('.video-library__card');
        const $loadMoreWrapper = $block.find('.video-library__load-more-wrapper');
        const $loadMoreBtn = $loadMoreWrapper.find('.video-library__load-more-btn');

        if (!$cards.length) {
            return;
        }

        const visibleRowsDesktop = parseInt($grid.attr('data-video-visible-rows'), 10) || 4;
        const visibleRowsTablet = parseInt($grid.attr('data-video-visible-rows-tablet'), 10) || 3;
        const visibleRowsMobile = parseInt($grid.attr('data-video-visible-rows-mobile'), 10) || 4;
        const loadMoreRows = 2;
        let loadedPages = 0;
        let resizeTimer;

        function getColumns() {
            const w = $(window).width();
            if (w >= 1025) return 4;
            if (w >= 769) return 3;
            return 1;
        }

        function getInitialRows() {
            const w = $(window).width();
            if (w >= 1025) return visibleRowsDesktop;
            if (w >= 769) return visibleRowsTablet;
            return visibleRowsMobile;
        }

        function getVisibleCount() {
            return (getInitialRows() + loadedPages * loadMoreRows) * getColumns();
        }

        function applyVisibility() {
            const visibleCount = getVisibleCount();
            const total = $cards.length;

            $cards.each(function (i) {
                $(this).toggleClass('video-library__card--hidden', i >= visibleCount);
            });

            if ($loadMoreWrapper.length) {
                $loadMoreWrapper.toggle(visibleCount < total);
            }
        }

        applyVisibility();

        $cards.each(function (i) {
            if (i < getVisibleCount()) {
                $(this).attr({
                    'data-aos': 'fade-up',
                    'data-aos-duration': '1000',
                    'data-aos-delay': i * 50
                });
            }
        });

        if (typeof AOS !== 'undefined') {
            AOS.refreshHard();
        }

        $(window).on('resize', function () {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(applyVisibility, 150);
        });

        if ($loadMoreBtn.length) {
            $loadMoreBtn.on('click', function () {
                const prevVisibleCount = getVisibleCount();
                loadedPages++;
                applyVisibility();
                const newVisibleCount = getVisibleCount();

                $cards.each(function (i) {
                    if (i >= prevVisibleCount && i < newVisibleCount) {
                        const $card = $(this);
                        const $prev = $card.prev();
                        $card.detach()
                            .removeAttr('data-aos')
                            .removeAttr('data-aos-duration')
                            .removeAttr('data-aos-delay')
                            .removeClass('aos-animate')
                            .attr({
                                'data-aos': 'fade-up',
                                'data-aos-duration': '1000',
                                'data-aos-delay': (i - prevVisibleCount) * 50
                            });
                        if ($prev.length) {
                            $prev.after($card);
                        } else {
                            $grid.prepend($card);
                        }
                    }
                });

                if (typeof AOS !== 'undefined') {
                    AOS.refreshHard();
                }

                if (getVisibleCount() >= $cards.length) {
                    $loadMoreWrapper.fadeOut();
                }
            });
        }
    });
});
